import React from "react";
import "./health.css";
import { getConfig } from '../../common/config';

const Health = () => {
  const version = getConfig('VERSION', 'unknown');
  
  return (
    <div className="health-container">
      Version: {version}
    </div>
  );
};

export default Health;
